// // // src/components/charting/ReportingTab.tsx
// // import React, { useMemo, useState } from "react";
// // import { useParams } from "react-router-dom";
// // // import { useNavigate } from "react-router-dom";
// // import { useNavigate, useLocation } from "react-router-dom";
// // import "../../css/ReportingTab.css";
// // import { ChartingState } from "../../pages/DentalChartingScreen";
// // import { useAuth } from "../../context/AuthContext";
// // import api from "../../api/axiosConfig";

// // interface ReportingTabProps {
// //   chartingData: ChartingState;
// //   onSubmitReport?: (payload: any) => void; // optional callback if parent wants it
// // }

// // const MAXILLARY_TEETH_IDS = [55, 54, 53, 52, 51, 61, 62, 63, 64, 65];
// // const MANDIBULAR_TEETH_IDS = [85, 84, 83, 82, 81, 71, 72, 73, 74, 75];

// // type PreventiveHome = {
// //   brushingAdvice: string;
// //   toothpasteAmount: string;
// //   fluorideToothpaste: string;
// //   brushingTime: string;
// //   fluorideMouthRinse: string;
// //   brushingPattern: string;
// //   sugarIntake: string;
// //   changeOfBrush: string;
// //   dietaryAdvice: string;
// //   typeOfBrush: string;
// // };

// // type PreventiveClinical = {
// //   sealants: string;
// //   fluorideVarnish: string;
// //   fluorideGels: string;
// //   professionalCleaning: string;
// //   dentistVisitInterval: string;
// // };

// // type LesionRow = {
// //   occlusal: string;
// //   mesioDistal: string;
// //   smoothSurface: string;
// //   other: string;
// // };

// // type ReportingData = {
// //   preventiveHome: PreventiveHome;
// //   preventiveClinical: PreventiveClinical;
// //   lesions: {
// //     maxillary: Record<number, LesionRow>;
// //     mandibular: Record<number, LesionRow>;
// //   };
// //   recommendationsText: string;
// // };

// // const REQUIRED_MSG = "This must fill";

// // const emptyHome: PreventiveHome = {
// //   brushingAdvice: "",
// //   toothpasteAmount: "",
// //   fluorideToothpaste: "",
// //   brushingTime: "",
// //   fluorideMouthRinse: "",
// //   brushingPattern: "",
// //   sugarIntake: "",
// //   changeOfBrush: "",
// //   dietaryAdvice: "",
// //   typeOfBrush: "",
// // };

// // const emptyClinical: PreventiveClinical = {
// //   sealants: "",
// //   fluorideVarnish: "",
// //   fluorideGels: "",
// //   professionalCleaning: "",
// //   dentistVisitInterval: "",
// // };

// // const emptyLesionRow = (): LesionRow => ({
// //   occlusal: "",
// //   mesioDistal: "",
// //   smoothSurface: "",
// //   other: "",
// // });

// // const buildInitialLesions = (teeth: number[]) => {
// //   const obj: Record<number, LesionRow> = {};
// //   teeth.forEach((t) => (obj[t] = emptyLesionRow()));
// //   return obj;
// // };

// // const ReportingTab: React.FC<ReportingTabProps> = ({
// //   chartingData,
// //   onSubmitReport,
// // }) => {
// //   // const { emrId } = useParams<{ emrId: string }>();

// //   const { emrNumber } = useParams<{ emrNumber: string }>();
// //   const emrId = emrNumber;
// //   const { doctor } = useAuth();

// //   // INSIDE COMPONENT
// //   const navigate = useNavigate();
// //   // const location = useLocation();
// //   // const caseId = (location.state as any)?.caseId;

// //   const location = useLocation();
// // const caseId = (location.state as any)?.caseId;
// // const sessionId = (location.state as any)?.sessionId;

// //   const [reportingData, setReportingData] = useState<ReportingData>(() => ({
// //     preventiveHome: { ...emptyHome },
// //     preventiveClinical: { ...emptyClinical },
// //     lesions: {
// //       maxillary: buildInitialLesions(MAXILLARY_TEETH_IDS),
// //       mandibular: buildInitialLesions(MANDIBULAR_TEETH_IDS),
// //     },
// //     recommendationsText:
// //       `Restoration/Interim therapeutic Restoration (ITR) or SDF*** tx. of progressing lesions\n` +
// //       `Restoration/Interim therapeutic Restoration (ITR) or SDF tx. of cavitated lesions`,
// //   }));

// //   // key -> error message
// //   const [errors, setErrors] = useState<Record<string, string>>({});
// //   const [isReviewed, setIsReviewed] = useState(false);

// //   const setField = (path: string, value: string) => {
// //     // clear error on change
// //     setErrors((prev) => {
// //       if (!prev[path]) return prev;
// //       const next = { ...prev };
// //       delete next[path];
// //       return next;
// //     });

// //     setReportingData((prev) => {
// //       const next = structuredClone(prev);

// //       // tiny path setter: supports known paths used below
// //       // preventiveHome.xxx
// //       if (path.startsWith("preventiveHome.")) {
// //         const k = path.replace("preventiveHome.", "") as keyof PreventiveHome;
// //         next.preventiveHome[k] = value;
// //         return next;
// //       }

// //       // preventiveClinical.xxx
// //       if (path.startsWith("preventiveClinical.")) {
// //         const k = path.replace(
// //           "preventiveClinical.",
// //           "",
// //         ) as keyof PreventiveClinical;
// //         next.preventiveClinical[k] = value;
// //         return next;
// //       }

// //       // lesions.maxillary.55.occlusal
// //       if (path.startsWith("lesions.")) {
// //         const parts = path.split(".");
// //         // lesions, arch, toothId, field
// //         const arch = parts[1] as "maxillary" | "mandibular";
// //         const toothId = Number(parts[2]);
// //         const field = parts[3] as keyof LesionRow;
// //         next.lesions[arch][toothId][field] = value;
// //         return next;
// //       }

// //       if (path === "recommendationsText") {
// //         next.recommendationsText = value;
// //         return next;
// //       }

// //       return prev;
// //     });
// //   };

// //   const isInvalid = (path: string) => Boolean(errors[path]);

// //   const validate = (): Record<string, string> => {
// //     const e: Record<string, string> = {};

// //     // Preventive Home - all required
// //     (Object.keys(emptyHome) as (keyof PreventiveHome)[]).forEach((k) => {
// //       const path = `preventiveHome.${k}`;
// //       if (
// //         !reportingData.preventiveHome[k] ||
// //         reportingData.preventiveHome[k].trim() === ""
// //       ) {
// //         e[path] = REQUIRED_MSG;
// //       }
// //     });

// //     // Preventive Clinical - all required
// //     (Object.keys(emptyClinical) as (keyof PreventiveClinical)[]).forEach(
// //       (k) => {
// //         const path = `preventiveClinical.${k}`;
// //         if (
// //           !reportingData.preventiveClinical[k] ||
// //           reportingData.preventiveClinical[k].trim() === ""
// //         ) {
// //           e[path] = REQUIRED_MSG;
// //         }
// //       },
// //     );

// //     // Lesions - every tooth row must be filled
// //     const validateArch = (
// //       arch: "maxillary" | "mandibular",
// //       teeth: number[],
// //     ) => {
// //       teeth.forEach((toothId) => {
// //         const row = reportingData.lesions[arch][toothId];
// //         (
// //           [
// //             "occlusal",
// //             "mesioDistal",
// //             "smoothSurface",
// //             "other",
// //           ] as (keyof LesionRow)[]
// //         ).forEach((field) => {
// //           const path = `lesions.${arch}.${toothId}.${field}`;
// //           if (!row?.[field] || row[field].trim() === "") {
// //             e[path] = REQUIRED_MSG;
// //           }
// //         });
// //       });
// //     };

// //     validateArch("maxillary", MAXILLARY_TEETH_IDS);
// //     validateArch("mandibular", MANDIBULAR_TEETH_IDS);

// //     return e;
// //   };

// //   const scrollToFirstError = (e: Record<string, string>) => {
// //     const firstKey = Object.keys(e)[0];
// //     if (!firstKey) return;

// //     const el = document.querySelector(
// //       `[data-field="${firstKey}"]`,
// //     ) as HTMLElement | null;
// //     if (el) {
// //       el.scrollIntoView({ behavior: "smooth", block: "center" });
// //       // focus only if it's focusable
// //       if (typeof (el as any).focus === "function") (el as any).focus();
// //     }
// //   };

// //   const buildPayload = useMemo(() => {
// //     return {
// //       chartingData,
// //       reportingData: {
// //         preventiveHome: reportingData.preventiveHome,
// //         preventiveClinical: reportingData.preventiveClinical,
// //         lesions: reportingData.lesions,
// //         recommendationsText: reportingData.recommendationsText,
// //         reviewer: doctor ? `Dr. ${doctor.name}` : null,
// //       },
// //     };
// //   }, [chartingData, reportingData, doctor]);

// // //   const handleSubmit = async () => {
// // //     if (!emrId) {
// // //       alert("EMR ID missing");
// // //       return;
// // //     }

// // //     if (!isReviewed) {
// // //       alert("Please confirm review before submitting.");
// // //       return;
// // //     }

// // //     const e = validate();
// // //     setErrors(e);

// // //     if (Object.keys(e).length > 0) {
// // //       scrollToFirstError(e);
// // //       alert("Please fill the highlighted fields.");
// // //       return;
// // //     }

// // //     if (!caseId) {
// // //       alert("Case ID missing. Cannot end session.");
// // //       return;
// // //     }

// // //     const payload = {
// // //       // emrId: emrId || "EMR-123",
// // //       emrId,
// // //       chartType: "primary",
// // //       createdBy: doctor ? `Dr. ${doctor.name}` : "doctor_123",
// // //       reportingData: {
// // //         preventiveHome: reportingData.preventiveHome,
// // //         preventiveClinical: reportingData.preventiveClinical,
// // //         lesions: reportingData.lesions,
// // //         recommendationsText: reportingData.recommendationsText,
// // //       },
// // //     };

// // //     // try {
// // //     //   // 1️⃣ Save reporting
// // //     //   await api.dataCollectionApi.post(
// // //     //     "/api/teledocs/dental/reporting",
// // //     //     payload,
// // //     //   );

// // //     //   // 2️⃣ End TELE_DENTIST session
// // //     //   await api.CenterworkflowApi.post(
// // //     //     `/postworkflow/cases/${caseId}/tasks/TELE_DENTIST/complete`,
// // //     //     {
// // //     //       result: { notes: "Tele Dentist completed" },
// // //     //     },
// // //     //   );

// // //     //   alert("Reporting saved and session closed successfully");

// // //     //   // 3️⃣ Navigate back to patients list
// // //     //   navigate("/patients");
// // //     // } catch (err) {
// // //     //   console.error(err);
// // //     //   alert("Reporting saved, but session could not be closed.");
// // //     // }


// // // try {
// // //   await api.dataCollectionApi.post(
// // //     "/api/teledocs/dental/reporting",
// // //     payload
// // //   );

// // //   alert("Dental report submitted successfully");

// // //   navigate("/queue/teledental");

// // // } catch (err) {
// // //   console.error(err);
// // //   alert("Failed to submit dental report");
// // // }

// // //   };




// // const handleSubmit = async () => {
// //   if (!emrId) {
// //     alert("EMR ID missing");
// //     return;
// //   }

// //   if (!isReviewed) {
// //     alert("Please confirm review before submitting.");
// //     return;
// //   }

// //   const e = validate();
// //   setErrors(e);

// //   if (Object.keys(e).length > 0) {
// //     scrollToFirstError(e);
// //     alert("Please fill the highlighted fields.");
// //     return;
// //   }

// //   if (!sessionId) {
// //     alert("Session ID missing.");
// //     return;
// //   }

// //   const payload = {
// //     emrId,
// //     chartType: "primary",
// //     createdBy: doctor ? `Dr. ${doctor.name}` : "doctor_123",
// //     reportingData: {
// //       preventiveHome: reportingData.preventiveHome,
// //       preventiveClinical: reportingData.preventiveClinical,
// //       lesions: reportingData.lesions,
// //       recommendationsText: reportingData.recommendationsText,
// //     },
// //   };

// //   try {
// //     // STEP 1: Save dental report data
// //     await api.dataCollectionApi.post(
// //       "/api/teledocs/dental/reporting",
// //       payload
// //     );

// //     // STEP 2: Complete dentist workflow step
// //     await api.CenterworkflowApi.post(
// //       `/sessions/${sessionId}/tele-reporting/dentist/submit`,
// //       {
// //         remarks: "Dental completed"
// //       }
// //     );

// //     alert("Dental report submitted successfully");

// //     // STEP 3: Return to dental queue
// //     navigate("/queue/teledental");

// //   } catch (err) {
// //     console.error(err);
// //     alert("Failed to submit dental report");
// //   }
// // };

// //   // Options
// //   const lesionOptions = {
// //     main: ["Sealant", "Restoration", "Probable Pulp therapy"],
// //     other: ["SS crown", "Esthetic crown", "Strip crown", "Extraction"],
// //   };

// //   const renderLesionTable = (
// //     title: string,
// //     teeth: number[],
// //     arch: "maxillary" | "mandibular",
// //   ) => (
// //     <div className="lesion-table-wrapper">
// //       <h4>{title}</h4>
// //       <div className="lesion-table-scroll-container">
// //         <table className="lesions-table">
// //           <thead>
// //             <tr>
// //               <th>Tooth #</th>
// //               <th>Occlusal</th>
// //               <th>Miso Distal</th>
// //               <th>Smooth Surface</th>
// //               <th>Other</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {teeth.map((toothId) => {
// //               const base = `lesions.${arch}.${toothId}`;
// //               const row = reportingData.lesions[arch][toothId];
// //               return (
// //                 <tr key={toothId}>
// //                   <td>{toothId}</td>

// //                   <td>
// //                     <select
// //                       data-field={`${base}.occlusal`}
// //                       className={
// //                         isInvalid(`${base}.occlusal`) ? "field-error" : ""
// //                       }
// //                       value={row.occlusal}
// //                       onChange={(e) =>
// //                         setField(`${base}.occlusal`, e.target.value)
// //                       }
// //                     >
// //                       <option value="">Select</option>
// //                       {lesionOptions.main.map((o) => (
// //                         <option key={o} value={o}>
// //                           {o}
// //                         </option>
// //                       ))}
// //                     </select>
// //                     {isInvalid(`${base}.occlusal`) && (
// //                       <div className="error-text">
// //                         {errors[`${base}.occlusal`]}
// //                       </div>
// //                     )}
// //                   </td>

// //                   <td>
// //                     <select
// //                       data-field={`${base}.mesioDistal`}
// //                       className={
// //                         isInvalid(`${base}.mesioDistal`) ? "field-error" : ""
// //                       }
// //                       value={row.mesioDistal}
// //                       onChange={(e) =>
// //                         setField(`${base}.mesioDistal`, e.target.value)
// //                       }
// //                     >
// //                       <option value="">Select</option>
// //                       {lesionOptions.main.map((o) => (
// //                         <option key={o} value={o}>
// //                           {o}
// //                         </option>
// //                       ))}
// //                     </select>
// //                     {isInvalid(`${base}.mesioDistal`) && (
// //                       <div className="error-text">
// //                         {errors[`${base}.mesioDistal`]}
// //                       </div>
// //                     )}
// //                   </td>

// //                   <td>
// //                     <select
// //                       data-field={`${base}.smoothSurface`}
// //                       className={
// //                         isInvalid(`${base}.smoothSurface`) ? "field-error" : ""
// //                       }
// //                       value={row.smoothSurface}
// //                       onChange={(e) =>
// //                         setField(`${base}.smoothSurface`, e.target.value)
// //                       }
// //                     >
// //                       <option value="">Select</option>
// //                       {lesionOptions.main.map((o) => (
// //                         <option key={o} value={o}>
// //                           {o}
// //                         </option>
// //                       ))}
// //                     </select>
// //                     {isInvalid(`${base}.smoothSurface`) && (
// //                       <div className="error-text">
// //                         {errors[`${base}.smoothSurface`]}
// //                       </div>
// //                     )}
// //                   </td>

// //                   <td>
// //                     <select
// //                       data-field={`${base}.other`}
// //                       className={
// //                         isInvalid(`${base}.other`) ? "field-error" : ""
// //                       }
// //                       value={row.other}
// //                       onChange={(e) =>
// //                         setField(`${base}.other`, e.target.value)
// //                       }
// //                     >
// //                       <option value="">Select</option>
// //                       {lesionOptions.other.map((o) => (
// //                         <option key={o} value={o}>
// //                           {o}
// //                         </option>
// //                       ))}
// //                     </select>
// //                     {isInvalid(`${base}.other`) && (
// //                       <div className="error-text">
// //                         {errors[`${base}.other`]}
// //                       </div>
// //                     )}
// //                   </td>
// //                 </tr>
// //               );
// //             })}
// //           </tbody>
// //         </table>
// //       </div>
// //     </div>
// //   );

// //   return (
// //     <div className="reporting-container">
// //       <div className="section">
// //         <h3 className="section-title">Preventive Recommendations</h3>
// //         <p className="section-description">
// //           The following recommendations are targeted at preventing new lesions
// //           and for existing lesions from advancing further...
// //         </p>

// //         <div className="recommendations-grid">
// //           {/* Home Interventions */}
// //           <div className="recommendation-box">
// //             <h4>Preventive Home Interventions</h4>
// //             <div className="form-grid">
// //               {/* Helper to render select with validation */}
// //               {[
// //                 ["brushingAdvice", "Brushing Advice:", ["2 times /Day"]],
// //                 [
// //                   "toothpasteAmount",
// //                   "Toothpaste Amount:",
// //                   ["Rice size", "Pea size", "Half-length of brush"],
// //                 ],
// //                 [
// //                   "fluorideToothpaste",
// //                   "Toothpaste/ Remineralization ",
// //                   ["Low fluoride (less than or equal to 500 ppm F)", "High fluoride (1000 ppm F)"],
// //                 ],
// //                 [
// //                   "brushingTime",
// //                   "Brushing Time:",
// //                   ["Minimum 2 Minutes brushing"],
// //                 ],
// //                 [
// //                   "fluorideMouthRinse",
// //                   "Fluoride Mouth Rinse:",
// //                   ["0.2% NaF/ Weekly Use", "0.05% NaF/ Daily Use"],
// //                 ],
// //                 [
// //                   "brushingPattern",
// //                   "Brushing Pattern:",
// //                   ["Supervised Circular brushing"],
// //                 ],
// //                 ["sugarIntake", "Sugar intake:", ["Maximum 3 times"]],
// //                 [
// //                   "changeOfBrush",
// //                   "Change of Brush:",
// //                   ["change every 3–6 months"],
// //                 ],
// //                 [
// //                   "dietaryAdvice",
// //                   "Dietary Advice:",
// //                   [
// //                     "3 major meals/day",
// //                     "3-5 major meals/day",
// //                     "More than 5 meals/day",
// //                   ],
// //                 ],
// //                 [
// //                   "typeOfBrush",
// //                   "Type of Brush:",
// //                   ["Age-appropriate soft toothbrush"],
// //                 ],
// //               ].map(([key, label, opts]) => {
// //                 const path = `preventiveHome.${key}`;
// //                 const k = key as keyof PreventiveHome;
// //                 return (
// //                   <div className="form-field" key={path}>
// //                     <label>{label}</label>
// //                     <select
// //                       data-field={path}
// //                       className={isInvalid(path) ? "field-error" : ""}
// //                       value={reportingData.preventiveHome[k]}
// //                       onChange={(e) => setField(path, e.target.value)}
// //                     >
// //                       <option value="">Select</option>
// //                       {(opts as string[]).map((o) => (
// //                         <option key={o} value={o}>
// //                           {o}
// //                         </option>
// //                       ))}
// //                     </select>
// //                     {isInvalid(path) && (
// //                       <div className="error-text">{errors[path]}</div>
// //                     )}
// //                   </div>
// //                 );
// //               })}
// //             </div>
// //           </div>

// //           {/* Clinical Interventions */}
// //           <div className="recommendation-box">
// //             <h4>Preventive Clinical Interventions</h4>
// //             <div className="form-grid-single">
// //               {[
// //                 ["sealants", "Sealants:", ["Recommended", "Non-Recommended"]],
// //                 [
// //                   "fluorideVarnish",
// //                   "Fluoride Varnish:",
// //                   [
// //                     "Every 3 Months",
// //                     "Every 6 months",
// //                     "Every 12 Months",
// //                     "Not recommended",
// //                   ],
// //                 ],
// //                 [
// //                   "fluorideGels",
// //                   "Fluoride Gels:",
// //                   [
// //                     "Every 3 Months",
// //                     "Every 6 months",
// //                     "Every 12 Months",
// //                     "Not recommended",
// //                   ],
// //                 ],
// //                 [
// //                   "professionalCleaning",
// //                   "Dentist Visit Interval Exam(E)/ Radiograph(R)",
// //                   ["Every 6 months E/R", "Every 6-12 Months E/R", "Every 12 Months E/R"],
// //                 ],
// //                 [
// //                   "dentistVisitInterval",
// //                   "Dentist Visit Interval:",
// //                   ["Every 3 Months", "Every 6 months", "Every 12 Months"],
// //                 ],
// //               ].map(([key, label, opts]) => {
// //                 const path = `preventiveClinical.${key}`;
// //                 const k = key as keyof PreventiveClinical;
// //                 return (
// //                   <div className="form-field" key={path}>
// //                     <label>{label}</label>
// //                     <select
// //                       data-field={path}
// //                       className={isInvalid(path) ? "field-error" : ""}
// //                       value={reportingData.preventiveClinical[k]}
// //                       onChange={(e) => setField(path, e.target.value)}
// //                     >
// //                       <option value="">Select</option>
// //                       {(opts as string[]).map((o) => (
// //                         <option key={o} value={o}>
// //                           {o}
// //                         </option>
// //                       ))}
// //                     </select>
// //                     {isInvalid(path) && (
// //                       <div className="error-text">{errors[path]}</div>
// //                     )}
// //                   </div>
// //                 );
// //               })}
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Lesions */}
// //       <div className="section">
// //         <h3 className="section-title">Managing Individual Lesions</h3>
// //         <p className="section-description">
// //           The following are the "Tooth-Preserving Operative Principles" to guide
// //           the decisions of dentists for restorative care.
// //         </p>
// //         <div className="lesions-grid">
// //           {renderLesionTable(
// //             "Maxillary Teeth",
// //             MAXILLARY_TEETH_IDS,
// //             "maxillary",
// //           )}
// //           {renderLesionTable(
// //             "Mandibular Teeth",
// //             MANDIBULAR_TEETH_IDS,
// //             "mandibular",
// //           )}
// //         </div>
// //       </div>

// //       {/* Recommended textarea (optional required? currently not required) */}
// //       <div className="section">
// //         <div className="recommended-box">
// //           <label htmlFor="recommendations-text">recommendation:</label>
// //           <textarea
// //             id="recommendations-text"
// //             placeholder="Fill the recommended details..."
// //             value={reportingData.recommendationsText}
// //             onChange={(e) => setField("recommendationsText", e.target.value)}
// //             rows={4}
// //           />
// //         </div>
// //       </div>

// //       <div className="submission-buttons">
// //         {/* {doctor && (
// //           <span className="reviewer-name">Reviewed by Dr. {doctor.name}</span>
// //         )} */}
// //         {doctor && (
// //           <label className="review-checkbox">
// //             <input
// //               type="checkbox"
// //               checked={isReviewed}
// //               onChange={(e) => setIsReviewed(e.target.checked)}
// //             />
// //             Reviewed by Dr. {doctor.name}
// //           </label>
// //         )}
// //         <button className="submit-btn" onClick={handleSubmit}>
// //           Submit
// //         </button>
// //         <button
// //           className="reset-btn"
// //           onClick={() => {
// //             setReportingData({
// //               preventiveHome: { ...emptyHome },
// //               preventiveClinical: { ...emptyClinical },
// //               lesions: {
// //                 maxillary: buildInitialLesions(MAXILLARY_TEETH_IDS),
// //                 mandibular: buildInitialLesions(MANDIBULAR_TEETH_IDS),
// //               },
// //               recommendationsText: reportingData.recommendationsText, // keep template text
// //             });
// //             setErrors({});
// //           }}
// //         >
// //           Reset
// //         </button>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ReportingTab;



// import React, { useMemo, useState } from "react";
// import { useParams } from "react-router-dom";
// import { useNavigate, useLocation } from "react-router-dom";
// import "../../css/ReportingTab.css";
// import { ChartingState } from "../../pages/DentalChartingScreen";
// import { useAuth } from "../../context/AuthContext";
// import api from "../../api/axiosConfig";

// interface ReportingTabProps {
//   chartingData: ChartingState;
//   onSubmitReport?: (payload: any) => void; // optional callback if parent wants it
// }

// const MAXILLARY_TEETH_IDS = [55, 54, 53, 52, 51, 61, 62, 63, 64, 65];
// const MANDIBULAR_TEETH_IDS = [85, 84, 83, 82, 81, 71, 72, 73, 74, 75];

// type PreventiveHome = {
//   brushingAdvice: string;
//   toothpasteAmount: string;
//   fluorideToothpaste: string;
//   brushingTime: string;
//   fluorideMouthRinse: string;
//   brushingPattern: string;
//   sugarIntake: string;
//   changeOfBrush: string;
//   dietaryAdvice: string;
//   typeOfBrush: string;
// };

// type PreventiveClinical = {
//   sealants: string;
//   fluorideVarnish: string;
//   fluorideGels: string;
//   professionalCleaning: string;
//   dentistVisitInterval: string;
// };

// type LesionRow = {
//   occlusal: string;
//   mesioDistal: string;
//   smoothSurface: string;
//   other: string;
// };

// type ReportingData = {
//   preventiveHome: PreventiveHome;
//   preventiveClinical: PreventiveClinical;
//   lesions: {
//     maxillary: Record<number, LesionRow>;
//     mandibular: Record<number, LesionRow>;
//   };
//   recommendationsText: string;
// };


// const emptyHome: PreventiveHome = {
//   brushingAdvice: "",
//   toothpasteAmount: "",
//   fluorideToothpaste: "",
//   brushingTime: "",
//   fluorideMouthRinse: "",
//   brushingPattern: "",
//   sugarIntake: "",
//   changeOfBrush: "",
//   dietaryAdvice: "",
//   typeOfBrush: "",
// };

// const emptyClinical: PreventiveClinical = {
//   sealants: "",
//   fluorideVarnish: "",
//   fluorideGels: "",
//   professionalCleaning: "",
//   dentistVisitInterval: "",
// };

// const emptyLesionRow = (): LesionRow => ({
//   occlusal: "",
//   mesioDistal: "",
//   smoothSurface: "",
//   other: "",
// });

// const buildInitialLesions = (teeth: number[]) => {
//   const obj: Record<number, LesionRow> = {};
//   teeth.forEach((t) => (obj[t] = emptyLesionRow()));
//   return obj;
// };

// const ReportingTab: React.FC<ReportingTabProps> = ({
//   chartingData,
//   onSubmitReport,
// }) => {

//   const { emrNumber } = useParams<{ emrNumber: string }>();
//   const emrId = emrNumber;
//   const { doctor, currentUser } = useAuth();

//   const navigate = useNavigate();

//   const location = useLocation();
// const caseId = (location.state as any)?.caseId;
// const sessionId = (location.state as any)?.sessionId;

//   const [reportingData, setReportingData] = useState<ReportingData>(() => ({
//     preventiveHome: { ...emptyHome },
//     preventiveClinical: { ...emptyClinical },
//     lesions: {
//       maxillary: buildInitialLesions(MAXILLARY_TEETH_IDS),
//       mandibular: buildInitialLesions(MANDIBULAR_TEETH_IDS),
//     },
//     recommendationsText:
//       `Restoration/Interim therapeutic Restoration (ITR) or SDF*** tx. of progressing lesions\n` +
//       `Restoration/Interim therapeutic Restoration (ITR) or SDF tx. of cavitated lesions`,
//   }));

//   const [isReviewed, setIsReviewed] = useState(false);

//   const setField = (path: string, value: string) => {
//     setReportingData((prev) => {
//       const next = structuredClone(prev);

//       if (path.startsWith("preventiveHome.")) {
//         const k = path.replace("preventiveHome.", "") as keyof PreventiveHome;
//         next.preventiveHome[k] = value;
//         return next;
//       }

//       if (path.startsWith("preventiveClinical.")) {
//         const k = path.replace(
//           "preventiveClinical.",
//           "",
//         ) as keyof PreventiveClinical;
//         next.preventiveClinical[k] = value;
//         return next;
//       }

//       if (path.startsWith("lesions.")) {
//         const parts = path.split(".");
//         const arch = parts[1] as "maxillary" | "mandibular";
//         const toothId = Number(parts[2]);
//         const field = parts[3] as keyof LesionRow;
//         next.lesions[arch][toothId][field] = value;
//         return next;
//       }

//       if (path === "recommendationsText") {
//         next.recommendationsText = value;
//         return next;
//       }

//       return prev;
//     });
//   };

//   const buildPayload = useMemo(() => {
//     return {
//       chartingData,
//       reportingData: {
//         preventiveHome: reportingData.preventiveHome,
//         preventiveClinical: reportingData.preventiveClinical,
//         lesions: reportingData.lesions,
//         recommendationsText: reportingData.recommendationsText,
//         reviewer: doctor ? `Dr. ${doctor.name}` : null,
//       },
//     };
//   }, [chartingData, reportingData, doctor]);




















// const handleSubmit = async () => {
//     if (!emrId) {
//       alert("EMR ID missing");
//       return;
//     }

//     if (!isReviewed) {
//       alert("Please confirm review before submitting.");
//       return;
//     }

//     if (!sessionId) {
//       alert("Session ID missing.");
//       return;
//     }

//     // Backend requires the internal doctor/user ID.
//     // Use user._id, not the Auth0 ID.
//     const doctorId = currentUser?.user?._id;

//     if (!doctorId) {
//       console.error(
//         "Doctor ID is missing from currentUser:",
//         currentUser,
//       );

//       alert("Doctor ID missing. Please login again.");
//       return;
//     }

//     const doctorName =
//       currentUser?.user?.raw?.name ||
//       doctor?.name ||
//       "";

//     const payload = {
//       emrId,
//       chartType: "primary",
//       doctorId,
//       createdBy: doctorName
//         ? `Dr. ${doctorName}`
//         : "doctor_123",
//       reportingData: {
//         preventiveHome: reportingData.preventiveHome,
//         preventiveClinical: reportingData.preventiveClinical,
//         lesions: reportingData.lesions,
//         recommendationsText: reportingData.recommendationsText,
//       },
//     };

//     console.log("[DENTAL REPORT] Submitting payload:", {
//       emrId,
//       doctorId,
//       doctorName,
//       sessionId,
//     });

//     try {
//       // Save dental reporting data.
//       await api.dataCollectionApi.post(
//         "/api/teledocs/dental/reporting",
//         payload,
//       );

//       // Existing dentist workflow completion.
//       await api.CenterworkflowApi.post(
//         `/sessions/${sessionId}/tele-reporting/dentist/submit`,
//         {
//           remarks: "Dental completed",
//         },
//       );

//       // Existing queue navigation.
//       alert("Dental report submitted successfully");

//       navigate("/queue/teledental");
//     } catch (err: any) {
//       console.error(
//         "[DENTAL REPORT SUBMIT FAILED]",
//         err,
//       );

//       const backendMessage =
//         err?.response?.data?.message ||
//         err?.response?.data?.error;

//       alert(
//         backendMessage ||
//           "Failed to submit dental report",
//       );
//     }
//   };

//   const lesionOptions = {
//     main: ["Sealant", "Restoration", "Probable Pulp therapy"],
//     other: ["SS crown", "Esthetic crown", "Strip crown", "Extraction"],
//   };

//   const renderLesionTable = (
//     title: string,
//     teeth: number[],
//     arch: "maxillary" | "mandibular",
//   ) => (
//     <div className="lesion-table-wrapper">
//       <h4>{title}</h4>
//       <div className="lesion-table-scroll-container">
//         <table className="lesions-table">
//           <thead>
//             <tr>
//               <th>Tooth #</th>
//               <th>Occlusal</th>
//               <th>Miso Distal</th>
//               <th>Smooth Surface</th>
//               <th>Other</th>
//             </tr>
//           </thead>
//           <tbody>
//             {teeth.map((toothId) => {
//               const base = `lesions.${arch}.${toothId}`;
//               const row = reportingData.lesions[arch][toothId];
//               return (
//                 <tr key={toothId}>
//                   <td>{toothId}</td>

//                   <td>
//                     <select
//                       data-field={`${base}.occlusal`}
//                       value={row.occlusal}
//                       onChange={(e) =>
//                         setField(`${base}.occlusal`, e.target.value)
//                       }
//                     >
//                       <option value="">Select</option>
//                       {lesionOptions.main.map((o) => (
//                         <option key={o} value={o}>
//                           {o}
//                         </option>
//                       ))}
//                     </select>
//                   </td>

//                   <td>
//                     <select
//                       data-field={`${base}.mesioDistal`}
//                       value={row.mesioDistal}
//                       onChange={(e) =>
//                         setField(`${base}.mesioDistal`, e.target.value)
//                       }
//                     >
//                       <option value="">Select</option>
//                       {lesionOptions.main.map((o) => (
//                         <option key={o} value={o}>
//                           {o}
//                         </option>
//                       ))}
//                     </select>
//                   </td>

//                   <td>
//                     <select
//                       data-field={`${base}.smoothSurface`}
//                       value={row.smoothSurface}
//                       onChange={(e) =>
//                         setField(`${base}.smoothSurface`, e.target.value)
//                       }
//                     >
//                       <option value="">Select</option>
//                       {lesionOptions.main.map((o) => (
//                         <option key={o} value={o}>
//                           {o}
//                         </option>
//                       ))}
//                     </select>
//                   </td>

//                   <td>
//                     <select
//                       data-field={`${base}.other`}
//                       value={row.other}
//                       onChange={(e) =>
//                         setField(`${base}.other`, e.target.value)
//                       }
//                     >
//                       <option value="">Select</option>
//                       {lesionOptions.other.map((o) => (
//                         <option key={o} value={o}>
//                           {o}
//                         </option>
//                       ))}
//                     </select>
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );

//   return (
//     <div className="reporting-container">
//       <div className="section">
//         <h3 className="section-title">Preventive Recommendations</h3>
//         <p className="section-description">
//           The following recommendations are targeted at preventing new lesions
//           and for existing lesions from advancing further...
//         </p>

//         <div className="recommendations-grid">
//           {/* Home Interventions */}
//           <div className="recommendation-box">
//             <h4>Preventive Home Interventions</h4>
//             <div className="form-grid">
//               {[
//                 ["brushingAdvice", "Brushing Advice:", ["2 times /Day"]],
//                 [
//                   "toothpasteAmount",
//                   "Toothpaste Amount:",
//                   ["Rice size", "Pea size", "Half-length of brush"],
//                 ],
//                 [
//                   "fluorideToothpaste",
//                   "Toothpaste/ Remineralization ",
//                   ["Low fluoride (less than or equal to 500 ppm F)", "High fluoride (1000 ppm F)"],
//                 ],
//                 [
//                   "brushingTime",
//                   "Brushing Time:",
//                   ["Minimum 2 Minutes brushing"],
//                 ],
//                 [
//                   "fluorideMouthRinse",
//                   "Fluoride Mouth Rinse:",
//                   ["0.2% NaF/ Weekly Use", "0.05% NaF/ Daily Use"],
//                 ],
//                 [
//                   "brushingPattern",
//                   "Brushing Pattern:",
//                   ["Supervised Circular brushing"],
//                 ],
//                 ["sugarIntake", "Sugar intake:", ["Maximum 3 times"]],
//                 [
//                   "changeOfBrush",
//                   "Change of Brush:",
//                   ["change every 3–6 months"],
//                 ],
//                 [
//                   "dietaryAdvice",
//                   "Dietary Advice:",
//                   [
//                     "3 major meals/day",
//                     "3-5 major meals/day",
//                     "More than 5 meals/day",
//                   ],
//                 ],
//                 [
//                   "typeOfBrush",
//                   "Type of Brush:",
//                   ["Age-appropriate soft toothbrush"],
//                 ],
//               ].map(([key, label, opts]) => {
//                 const path = `preventiveHome.${key}`;
//                 const k = key as keyof PreventiveHome;
//                 return (
//                   <div className="form-field" key={path}>
//                     <label>{label}</label>
//                     <select
//                       data-field={path}
//                       value={reportingData.preventiveHome[k]}
//                       onChange={(e) => setField(path, e.target.value)}
//                     >
//                       <option value="">Select</option>
//                       {(opts as string[]).map((o) => (
//                         <option key={o} value={o}>
//                           {o}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>

//           {/* Clinical Interventions */}
//           <div className="recommendation-box">
//             <h4>Preventive Clinical Interventions</h4>
//             <div className="form-grid-single">
//               {[
//                 ["sealants", "Sealants:", ["Recommended", "Non-Recommended"]],
//                 [
//                   "fluorideVarnish",
//                   "Fluoride Varnish:",
//                   [
//                     "Every 3 Months",
//                     "Every 6 months",
//                     "Every 12 Months",
//                     "Not recommended",
//                   ],
//                 ],
//                 [
//                   "fluorideGels",
//                   "Fluoride Gels:",
//                   [
//                     "Every 3 Months",
//                     "Every 6 months",
//                     "Every 12 Months",
//                     "Not recommended",
//                   ],
//                 ],
//                 [
//                   "professionalCleaning",
//                   "Dentist Visit Interval Exam(E)/ Radiograph(R)",
//                   ["Every 6 months E/R", "Every 6-12 Months E/R", "Every 12 Months E/R"],
//                 ],
//                 [
//                   "dentistVisitInterval",
//                   "Dentist Visit Interval:",
//                   ["Every 3 Months", "Every 6 months", "Every 12 Months"],
//                 ],
//               ].map(([key, label, opts]) => {
//                 const path = `preventiveClinical.${key}`;
//                 const k = key as keyof PreventiveClinical;
//                 return (
//                   <div className="form-field" key={path}>
//                     <label>{label}</label>
//                     <select
//                       data-field={path}
//                       value={reportingData.preventiveClinical[k]}
//                       onChange={(e) => setField(path, e.target.value)}
//                     >
//                       <option value="">Select</option>
//                       {(opts as string[]).map((o) => (
//                         <option key={o} value={o}>
//                           {o}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Lesions */}
//       <div className="section">
//         <h3 className="section-title">Managing Individual Lesions</h3>
//         <p className="section-description">
//           The following are the "Tooth-Preserving Operative Principles" to guide
//           the decisions of dentists for restorative care.
//         </p>
//         <div className="lesions-grid">
//           {renderLesionTable(
//             "Maxillary Teeth",
//             MAXILLARY_TEETH_IDS,
//             "maxillary",
//           )}
//           {renderLesionTable(
//             "Mandibular Teeth",
//             MANDIBULAR_TEETH_IDS,
//             "mandibular",
//           )}
//         </div>
//       </div>

//       {/* Recommended textarea (optional required? currently not required) */}
//       <div className="section">
//         <div className="recommended-box">
//           <label htmlFor="recommendations-text">recommendation:</label>
//           <textarea
//             id="recommendations-text"
//             placeholder="Fill the recommended details..."
//             value={reportingData.recommendationsText}
//             onChange={(e) => setField("recommendationsText", e.target.value)}
//             rows={4}
//           />
//         </div>
//       </div>

//       <div className="submission-buttons">
//         {/* {doctor && (
//           <span className="reviewer-name">Reviewed by Dr. {doctor.name}</span>
//         )} */}
//         {doctor && (
//           <label className="review-checkbox">
//             <input
//               type="checkbox"
//               checked={isReviewed}
//               onChange={(e) => setIsReviewed(e.target.checked)}
//             />
//             Reviewed by Dr. {doctor.name}
//           </label>
//         )}
//         <button className="submit-btn" onClick={handleSubmit}>
//           Submit
//         </button>
//         <button
//           className="reset-btn"
//           onClick={() => {
//             setReportingData({
//               preventiveHome: { ...emptyHome },
//               preventiveClinical: { ...emptyClinical },
//               lesions: {
//                 maxillary: buildInitialLesions(MAXILLARY_TEETH_IDS),
//                 mandibular: buildInitialLesions(MANDIBULAR_TEETH_IDS),
//               },
//               recommendationsText: reportingData.recommendationsText, // keep template text
//             });
//           }}
//         >
//           Reset
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ReportingTab;






import React, { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import "../../css/ReportingTab.css";
import { ChartingState } from "../../pages/DentalChartingScreen";
import { useAuth } from "../../context/AuthContext";
import api from "../../api/axiosConfig";

interface ReportingTabProps {
  chartingData: ChartingState;
  onSubmitReport?: (payload: any) => void; // optional callback if parent wants it
}

const MAXILLARY_TEETH_IDS = [55, 54, 53, 52, 51, 61, 62, 63, 64, 65];
const MANDIBULAR_TEETH_IDS = [85, 84, 83, 82, 81, 71, 72, 73, 74, 75];

type PreventiveHome = {
  brushingAdvice: string;
  toothpasteAmount: string;
  fluorideToothpaste: string;
  brushingTime: string;
  fluorideMouthRinse: string;
  brushingPattern: string;
  sugarIntake: string;
  changeOfBrush: string;
  dietaryAdvice: string;
  typeOfBrush: string;
};

type PreventiveClinical = {
  sealants: string;
  fluorideVarnish: string;
  fluorideGels: string;
  professionalCleaning: string;
  dentistVisitInterval: string;
};

type LesionRow = {
  occlusal: string;
  mesioDistal: string;
  smoothSurface: string;
  other: string;
};

type ReportingData = {
  preventiveHome: PreventiveHome;
  preventiveClinical: PreventiveClinical;
  lesions: {
    maxillary: Record<number, LesionRow>;
    mandibular: Record<number, LesionRow>;
  };
  recommendationsText: string;
};


const emptyHome: PreventiveHome = {
  brushingAdvice: "",
  toothpasteAmount: "",
  fluorideToothpaste: "",
  brushingTime: "",
  fluorideMouthRinse: "",
  brushingPattern: "",
  sugarIntake: "",
  changeOfBrush: "",
  dietaryAdvice: "",
  typeOfBrush: "",
};

const emptyClinical: PreventiveClinical = {
  sealants: "",
  fluorideVarnish: "",
  fluorideGels: "",
  professionalCleaning: "",
  dentistVisitInterval: "",
};

const emptyLesionRow = (): LesionRow => ({
  occlusal: "",
  mesioDistal: "",
  smoothSurface: "",
  other: "",
});

const buildInitialLesions = (teeth: number[]) => {
  const obj: Record<number, LesionRow> = {};
  teeth.forEach((t) => (obj[t] = emptyLesionRow()));
  return obj;
};

const ReportingTab: React.FC<ReportingTabProps> = ({
  chartingData,
  onSubmitReport,
}) => {

  const { emrNumber } = useParams<{ emrNumber: string }>();
  const emrId = emrNumber;
  const { doctor, currentUser } = useAuth();

  const navigate = useNavigate();

  const location = useLocation();
const caseId = (location.state as any)?.caseId;
const sessionId = (location.state as any)?.sessionId;

  const [reportingData, setReportingData] = useState<ReportingData>(() => ({
    preventiveHome: { ...emptyHome },
    preventiveClinical: { ...emptyClinical },
    lesions: {
      maxillary: buildInitialLesions(MAXILLARY_TEETH_IDS),
      mandibular: buildInitialLesions(MANDIBULAR_TEETH_IDS),
    },
    recommendationsText:
      `Restoration/Interim therapeutic Restoration (ITR) or SDF*** tx. of progressing lesions\n` +
      `Restoration/Interim therapeutic Restoration (ITR) or SDF tx. of cavitated lesions`,
  }));

  const [isReviewed, setIsReviewed] = useState(false);

  const setField = (path: string, value: string) => {
    setReportingData((prev) => {
      const next = structuredClone(prev);

      if (path.startsWith("preventiveHome.")) {
        const k = path.replace("preventiveHome.", "") as keyof PreventiveHome;
        next.preventiveHome[k] = value;
        return next;
      }

      if (path.startsWith("preventiveClinical.")) {
        const k = path.replace(
          "preventiveClinical.",
          "",
        ) as keyof PreventiveClinical;
        next.preventiveClinical[k] = value;
        return next;
      }

      if (path.startsWith("lesions.")) {
        const parts = path.split(".");
        const arch = parts[1] as "maxillary" | "mandibular";
        const toothId = Number(parts[2]);
        const field = parts[3] as keyof LesionRow;
        next.lesions[arch][toothId][field] = value;
        return next;
      }

      if (path === "recommendationsText") {
        next.recommendationsText = value;
        return next;
      }

      return prev;
    });
  };

  const buildPayload = useMemo(() => {
    return {
      chartingData,
      reportingData: {
        preventiveHome: reportingData.preventiveHome,
        preventiveClinical: reportingData.preventiveClinical,
        lesions: reportingData.lesions,
        recommendationsText: reportingData.recommendationsText,
        reviewer: doctor ? `Dr. ${doctor.name}` : null,
      },
    };
  }, [chartingData, reportingData, doctor]);




















const handleSubmit = async () => {
    if (!emrId) {
      alert("EMR ID missing");
      return;
    }

    if (!isReviewed) {
      alert("Please confirm review before submitting.");
      return;
    }

    if (!sessionId) {
      alert("Session ID missing.");
      return;
    }

    // Backend requires the internal doctor/user ID.
    // Use user._id, not the Auth0 ID.
    const doctorId = currentUser?.user?._id;

    if (!doctorId) {
      console.error(
        "Doctor ID is missing from currentUser:",
        currentUser,
      );

      alert("Doctor ID missing. Please login again.");
      return;
    }

    const doctorName =
      currentUser?.user?.raw?.name ||
      doctor?.name ||
      "";

    const payload = {
      emrId,
      chartType: "primary",
      doctorId,
      createdBy: doctorName
        ? `Dr. ${doctorName}`
        : "doctor_123",
      reportingData: {
        preventiveHome: reportingData.preventiveHome,
        preventiveClinical: reportingData.preventiveClinical,
        lesions: reportingData.lesions,
        recommendationsText: reportingData.recommendationsText,
      },
    };

    console.log("[DENTAL REPORT] Submitting payload:", {
      emrId,
      doctorId,
      doctorName,
      sessionId,
    });

    try {
      // Save dental reporting data.
      await api.dataCollectionApi.post(
        "/api/teledocs/dental/reporting",
        payload,
      );

      // Existing dentist workflow completion.
      await api.CenterworkflowApi.post(
        `/sessions/${sessionId}/tele-reporting/dentist/submit`,
        {
          doctorId,
          remarks: "Dental completed",
        },
      );

      // Existing queue navigation.
      alert("Dental report submitted successfully");

      navigate("/queue/teledental");
    } catch (err: any) {
      console.error(
        "[DENTAL REPORT SUBMIT FAILED]",
        err,
      );

      const backendMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error;

      alert(
        backendMessage ||
          "Failed to submit dental report",
      );
    }
  };

  const lesionOptions = {
    main: ["Sealant", "Restoration", "Probable Pulp therapy"],
    other: ["SS crown", "Esthetic crown", "Strip crown", "Extraction"],
  };

  const renderLesionTable = (
    title: string,
    teeth: number[],
    arch: "maxillary" | "mandibular",
  ) => (
    <div className="lesion-table-wrapper">
      <h4>{title}</h4>
      <div className="lesion-table-scroll-container">
        <table className="lesions-table">
          <thead>
            <tr>
              <th>Tooth #</th>
              <th>Occlusal</th>
              <th>Miso Distal</th>
              <th>Smooth Surface</th>
              <th>Other</th>
            </tr>
          </thead>
          <tbody>
            {teeth.map((toothId) => {
              const base = `lesions.${arch}.${toothId}`;
              const row = reportingData.lesions[arch][toothId];
              return (
                <tr key={toothId}>
                  <td>{toothId}</td>

                  <td>
                    <select
                      data-field={`${base}.occlusal`}
                      value={row.occlusal}
                      onChange={(e) =>
                        setField(`${base}.occlusal`, e.target.value)
                      }
                    >
                      <option value="">Select</option>
                      {lesionOptions.main.map((o) => (
                        <option key={o} value={o}>
                          {o}
                        </option>
                      ))}
                    </select>
                  </td>

                  <td>
                    <select
                      data-field={`${base}.mesioDistal`}
                      value={row.mesioDistal}
                      onChange={(e) =>
                        setField(`${base}.mesioDistal`, e.target.value)
                      }
                    >
                      <option value="">Select</option>
                      {lesionOptions.main.map((o) => (
                        <option key={o} value={o}>
                          {o}
                        </option>
                      ))}
                    </select>
                  </td>

                  <td>
                    <select
                      data-field={`${base}.smoothSurface`}
                      value={row.smoothSurface}
                      onChange={(e) =>
                        setField(`${base}.smoothSurface`, e.target.value)
                      }
                    >
                      <option value="">Select</option>
                      {lesionOptions.main.map((o) => (
                        <option key={o} value={o}>
                          {o}
                        </option>
                      ))}
                    </select>
                  </td>

                  <td>
                    <select
                      data-field={`${base}.other`}
                      value={row.other}
                      onChange={(e) =>
                        setField(`${base}.other`, e.target.value)
                      }
                    >
                      <option value="">Select</option>
                      {lesionOptions.other.map((o) => (
                        <option key={o} value={o}>
                          {o}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className="reporting-container">
      <div className="section">
        <h3 className="section-title">Preventive Recommendations</h3>
        <p className="section-description">
          The following recommendations are targeted at preventing new lesions
          and for existing lesions from advancing further...
        </p>

        <div className="recommendations-grid">
          {/* Home Interventions */}
          <div className="recommendation-box">
            <h4>Preventive Home Interventions</h4>
            <div className="form-grid">
              {[
                ["brushingAdvice", "Brushing Advice:", ["2 times /Day"]],
                [
                  "toothpasteAmount",
                  "Toothpaste Amount:",
                  ["Rice size", "Pea size", "Half-length of brush"],
                ],
                [
                  "fluorideToothpaste",
                  "Toothpaste/ Remineralization ",
                  ["Low fluoride (less than or equal to 500 ppm F)", "High fluoride (1000 ppm F)"],
                ],
                [
                  "brushingTime",
                  "Brushing Time:",
                  ["Minimum 2 Minutes brushing"],
                ],
                [
                  "fluorideMouthRinse",
                  "Fluoride Mouth Rinse:",
                  ["0.2% NaF/ Weekly Use", "0.05% NaF/ Daily Use"],
                ],
                [
                  "brushingPattern",
                  "Brushing Pattern:",
                  ["Supervised Circular brushing"],
                ],
                ["sugarIntake", "Sugar intake:", ["Maximum 3 times"]],
                [
                  "changeOfBrush",
                  "Change of Brush:",
                  ["change every 3–6 months"],
                ],
                [
                  "dietaryAdvice",
                  "Dietary Advice:",
                  [
                    "3 major meals/day",
                    "3-5 major meals/day",
                    "More than 5 meals/day",
                  ],
                ],
                [
                  "typeOfBrush",
                  "Type of Brush:",
                  ["Age-appropriate soft toothbrush"],
                ],
              ].map(([key, label, opts]) => {
                const path = `preventiveHome.${key}`;
                const k = key as keyof PreventiveHome;
                return (
                  <div className="form-field" key={path}>
                    <label>{label}</label>
                    <select
                      data-field={path}
                      value={reportingData.preventiveHome[k]}
                      onChange={(e) => setField(path, e.target.value)}
                    >
                      <option value="">Select</option>
                      {(opts as string[]).map((o) => (
                        <option key={o} value={o}>
                          {o}
                        </option>
                      ))}
                    </select>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Clinical Interventions */}
          <div className="recommendation-box">
            <h4>Preventive Clinical Interventions</h4>
            <div className="form-grid-single">
              {[
                ["sealants", "Sealants:", ["Recommended", "Non-Recommended"]],
                [
                  "fluorideVarnish",
                  "Fluoride Varnish:",
                  [
                    "Every 3 Months",
                    "Every 6 months",
                    "Every 12 Months",
                    "Not recommended",
                  ],
                ],
                [
                  "fluorideGels",
                  "Fluoride Gels:",
                  [
                    "Every 3 Months",
                    "Every 6 months",
                    "Every 12 Months",
                    "Not recommended",
                  ],
                ],
                [
                  "professionalCleaning",
                  "Dentist Visit Interval Exam(E)/ Radiograph(R)",
                  ["Every 6 months E/R", "Every 6-12 Months E/R", "Every 12 Months E/R"],
                ],
                [
                  "dentistVisitInterval",
                  "Dentist Visit Interval:",
                  ["Every 3 Months", "Every 6 months", "Every 12 Months"],
                ],
              ].map(([key, label, opts]) => {
                const path = `preventiveClinical.${key}`;
                const k = key as keyof PreventiveClinical;
                return (
                  <div className="form-field" key={path}>
                    <label>{label}</label>
                    <select
                      data-field={path}
                      value={reportingData.preventiveClinical[k]}
                      onChange={(e) => setField(path, e.target.value)}
                    >
                      <option value="">Select</option>
                      {(opts as string[]).map((o) => (
                        <option key={o} value={o}>
                          {o}
                        </option>
                      ))}
                    </select>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Lesions */}
      <div className="section">
        <h3 className="section-title">Managing Individual Lesions</h3>
        <p className="section-description">
          The following are the "Tooth-Preserving Operative Principles" to guide
          the decisions of dentists for restorative care.
        </p>
        <div className="lesions-grid">
          {renderLesionTable(
            "Maxillary Teeth",
            MAXILLARY_TEETH_IDS,
            "maxillary",
          )}
          {renderLesionTable(
            "Mandibular Teeth",
            MANDIBULAR_TEETH_IDS,
            "mandibular",
          )}
        </div>
      </div>

      {/* Recommended textarea (optional required? currently not required) */}
      <div className="section">
        <div className="recommended-box">
          <label htmlFor="recommendations-text">recommendation:</label>
          <textarea
            id="recommendations-text"
            placeholder="Fill the recommended details..."
            value={reportingData.recommendationsText}
            onChange={(e) => setField("recommendationsText", e.target.value)}
            rows={4}
          />
        </div>
      </div>

      <div className="submission-buttons">
        {/* {doctor && (
          <span className="reviewer-name">Reviewed by Dr. {doctor.name}</span>
        )} */}
        {doctor && (
          <label className="review-checkbox">
            <input
              type="checkbox"
              checked={isReviewed}
              onChange={(e) => setIsReviewed(e.target.checked)}
            />
            Reviewed by Dr. {doctor.name}
          </label>
        )}
        <button className="submit-btn" onClick={handleSubmit}>
          Submit
        </button>
        <button
          className="reset-btn"
          onClick={() => {
            setReportingData({
              preventiveHome: { ...emptyHome },
              preventiveClinical: { ...emptyClinical },
              lesions: {
                maxillary: buildInitialLesions(MAXILLARY_TEETH_IDS),
                mandibular: buildInitialLesions(MANDIBULAR_TEETH_IDS),
              },
              recommendationsText: reportingData.recommendationsText, // keep template text
            });
          }}
        >
          Reset
        </button>
      </div>
    </div>
  );
};

export default ReportingTab;

